import { gql } from 'graphql-tag';

export const GET_WORKSPACE = gql`
  query getWorkspace($workspaceID: UUID!) {
    getWorkspace(workspaceID: $workspaceID) {
      id: workspaceID
      workspaceID
      name
      code
      countryID
      currencyID
      currency {
        symbol
        decimalPlaces
      }
      languageID
      timezoneID
      checkoutDecimalPlaces
      checkoutRoundingRule
      calcDecimalPlaces
      calcRoundingRule
      discountDisplayFormat
    }
  }
`;

export const UPDATE_A_WORKSPACE = gql`
  mutation updateAWorkspace($input: UpdateAWorkspaceInput!) {
    updateAWorkspace(input: $input)
  }
`;

export const GET_WORKSPACE_DISCOUNT_DISPLAY_FORMAT = gql`
  query getWorkspaceDiscountDisplayFormat($workspaceID: UUID!) {
    getWorkspace(workspaceID: $workspaceID) {
      id: workspaceID
      discountDisplayFormat
    }
  }
`;

export const LOGIN = gql`
  mutation login($source: LoginSource!, $email: String!, $password: String!) {
    login(source: $source, email: $email, password: $password) {
      workspaceID
      permissions {
        permissionDetailID
        systemID
        code
      }
      roles {
        roleID
        roleTemplateID
        displayID
        name
        of
      }
    }
  }
`;

export const RECOVERY_PASSWORD = gql`
  mutation recoveryPassword($email: String!) {
    recoveryPassword(email: $email)
  }
`;

export const SEND_EMAIL_VERIFICATION = gql`
  mutation sendEmailVerification(
    $email: String!
    $type: EmailVerificationType!
  ) {
    sendEmailVerification(email: $email, type: $type)
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $verificationNumber: String!
    $email: String!
    $password: String!
  ) {
    resetPassword(
      verificationNumber: $verificationNumber
      email: $email
      password: $password
    )
  }
`;

export const INIT_PASSWORD = gql`
  mutation initPassword(
    $verificationNumber: String!
    $email: String!
    $password: String!
  ) {
    initPassword(
      verificationNumber: $verificationNumber
      email: $email
      password: $password
    )
  }
`;

export const INSPECT_VERIFICATION_NUMBER = gql`
  query inspectVerificationNumber(
    $email: String!
    $verificationNumber: String!
  ) {
    inspectVerificationNumber(
      email: $email
      verificationNumber: $verificationNumber
    )
  }
`;

export const ORG_BELONGS = gql`
  query orgBelongs {
    orgBelongs {
      of
      workspaceID
      workspace {
        workspaceID
        name
        countryID
      }
      brandID
      brand {
        brandID
        name
      }
      shopID
      shop {
        shopID
        name
      }
      employeeID
      employee {
        user {
          email
        }
        firstName
        lastName
        employeePortraits {
          hash
        }
      }
    }
  }
`;

export const GET_BRAND_ID = gql`
  query listBrandIDs($workspaceID: UUID!) {
    listBrands(workspaceID: $workspaceID) {
      brandID
    }
  }
`;

export const COUNT_SHOPS = gql`
  query countShops($workspaceID: UUID!) {
    countShops(workspaceID: $workspaceID) {
      brandID
      count
    }
  }
`;

export const GET_WORKSPACE_BRAND_SHOP = gql`
  query workspaceListBrands($workspaceID: UUID!) {
    listBrands(workspaceID: $workspaceID) {
      brandID
      name
      subBrands {
        shops {
          name
          shopID
        }
      }
      uncategorizedShops {
        name
        shopID
      }
      displayOrder
    }
  }
`;

export const VERSION = gql`
  query version {
    version {
      version
      goVersion
      name
      buildTime
      gitCommit
    }
  }
`;
